module.exports = __webpack_public_path__ + "media/images/icons/tasks-49f930314c8fbb3810da83922c7c0f4a.svg";